import type { UserGetProjectPostsParams, UserGetAgentPostsParams } from '../api'
import postService from './user-post.service'
import { EUserPostQueryKey } from './user-post.types'

export const getProjectPostsOptions = (params: UserGetProjectPostsParams) => {
  return {
    queryKey: [EUserPostQueryKey.PROJECT_POSTS, params],
    queryFn: () => postService.getProjectPosts(params),
  }
}

export const getAgentPostsOptions = (params: UserGetAgentPostsParams) => {
  return {
    queryKey: [EUserPostQueryKey.AGENT_POSTS, params],
    queryFn: () => postService.getAgentPosts(params),
  }
}
